export const CurrencyList =
  [
    "MUR",
    "EUR",
    "GBP",
    "USD",
    "CHF"
  ];



// WEBPACK FOOTER //
// ./src/app/common/enums/Currency.ts